import {Component, OnDestroy, OnInit} from '@angular/core';
import {
	NzTableData,
	NzTablePaginationPosition,
	NzTableSize
} from 'ng-zorro-antd/table/src/table.types';
import { ParticipantService} from '../../../services/participants/participant.service';
import { ProjectService } from '../../../services/project/project.service';
import {ProtectedPrivacyService} from '../../../services/ui/protected-privacy.service';
import { Subscription } from 'rxjs';
import { ProjectDto } from '@api/projects/interfaces';
import { SplitButtonElement } from '@app/components/elements/splitbutton/splitbutton.component';
import { Router } from '@angular/router';
import { projectPages } from '@app/pages/project/projects.routes';
import { MenuService } from '@app/services/menu';
import { PermissionService } from '@app/services/permission/permission.service';

@Component({
	selector: 'app-project-list',
	templateUrl: './project-list.component.html',
	styleUrls: ['./project-list.component.scss']
})
export class ProjectListComponent implements OnInit, OnDestroy {
	public simple = false;
	public loading = true;
	public pagination = true;
	public position: NzTablePaginationPosition = 'bottom';
	public header = true;
	public title = false;
	public expandable = true;
	public checkbox = false;
	public allChecked = false;
	public footer = false;
	public bordered = false;
	public sizeChanger = false;
	public size: NzTableSize = 'small';
	public privacyMode = false;
	public hasProject = false;
	public modalVisible = false;

	public nameFilterValue = '';
	public nameFilterVisible = false;
	public pidFilterValue = '';
	public pidFilterVisible = false;
	public serverFilterValue = '';
	public serverFilterVisible = false;
	public descriptionFilterValue = '';
	public descriptionFilterVisible = false;

	hasProjectCreatePermission = false;

	public projectAddSplitButton: SplitButtonElement = {
		title: 'projects.add',
		icon: 'plus',
		type: 'default',
		callback: () => this.showProjectCreate(),
	};

	public activeProject: ProjectDto;
	listOfData: ProjectDto[] = [];
	listOfDisplayData: ProjectDto[] = [];
	public selectedProject: ProjectDto;

	private subscription = new Subscription();

	constructor(
		private participantService: ParticipantService,
		private privacyService: ProtectedPrivacyService,
		private projectService: ProjectService,
		private router: Router,
		private menuService: MenuService,
		private permissionService: PermissionService,
	) {

	}

	ngOnInit(): void {
		this.subscription.add(this.projectService.activeProject$.subscribe(project => {
			this.activeProject = project;
		}));
		this.subscription.add(this.projectService.projects$.subscribe(projects => {
			this.listOfData = [...projects];
			this.loading = false;
			this.listOfDisplayData = this.listOfData;
		}));
		this.subscription.add(this.permissionService.hasGlobalPermission$('projects:create').subscribe(hasProjectCreatePermission => {
			this.hasProjectCreatePermission = hasProjectCreatePermission;
		}));
		this.menuService.title = 'participant.data.key.projects';
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}

	currentPageDataChange(event): void {

	}

	compareName(a: NzTableData, b: NzTableData): number {
		return a.projectname.localeCompare(b.projectname);
	}

	comparePid(a: NzTableData, b: NzTableData): number {
		return a.project_id.localeCompare(b.project_id);
	}

	compareServer(a: NzTableData, b: NzTableData): number {
		return a.server_id.localeCompare(b.server_id);
	}

	compareDescription(a: NzTableData, b: NzTableData): number {
		return a.description.localeCompare(b.description);
	}

	filterName(): void {
		if (this.nameFilterValue === '') {
			this.listOfDisplayData = this.listOfData;
		}
		this.listOfDisplayData = this.listOfData.filter(
			(item: ProjectDto) => item.projectname.toLowerCase().includes(this.nameFilterValue.toLowerCase())
		);
	}

	filterPid(): void {
		if (this.pidFilterValue === '') {
			this.listOfDisplayData = this.listOfData;
		}
		this.listOfDisplayData = this.listOfData.filter(
			(item: ProjectDto) => item.project_id.toLowerCase().includes(this.pidFilterValue.toLowerCase())
		);
	}

	filterServer(): void {
		if (this.serverFilterValue === '') {
			this.listOfDisplayData = this.listOfData;
		}
		this.listOfDisplayData = this.listOfData.filter(
			(item: ProjectDto) => item.server_id.toLowerCase().includes(this.serverFilterValue.toLowerCase())
		);
	}

	filterDescription(): void {
		if (this.descriptionFilterValue === '') {
			this.listOfDisplayData = this.listOfData;
		}
		this.listOfDisplayData = this.listOfData.filter(
			(item: ProjectDto) => item.description.toLowerCase().includes(this.descriptionFilterValue.toLowerCase())
		);
	}


	changeProject(project: ProjectDto): void {
		this.projectService.setActiveProject(project);
		this.handleCancel();
	}

	handleCancel(): void {
		this.selectedProject = null;
		this.modalVisible = false;
	}

	showProjectEdit (project: ProjectDto): void {
		this.router
			.navigate([projectPages.edit.base(project.project_id)])
			.catch(console.error);
	}

	showProjectCreate(): void {
		this.router
			.navigate([projectPages.create.base()])
			.catch(console.error);
	}
}
